export default <A, B>(a: A, b: B) => [a, b] as [A, B];
